import * as React from 'react';
import styles from './index.less';

interface TextButtonProps {
  text: string;
  size?: 'medium' | 'large';
  onClick?: () => void;
  style?: React.CSSProperties;
}

function TextButton({ text, size = 'medium', onClick, style = {} }: TextButtonProps) {
  return (
    <div
      className={styles.text_button}
      style={{
        fontSize: size === 'medium' ? 14 : 16,
        lineHeight: size === 'medium' ? '20px' : '22px',
        ...style,
      }}
      onClick={onClick}
    >
      {text}
    </div>
  );
}

export default TextButton;
